"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paragraph = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const P = styled_components_1.default.p `
	font-weight: 400;
	font-size: 16px;
	line-height: 30px;
	color: ${(p) => p.theme.palette.text.secondary || p.theme.palette.text.primary};
	font-family: ${(p) => p.theme.fonts.paragraph || p.theme.fonts.default};
	text-transform: none;
	font-style: normal;
	&.caption {
		font-size: 14px;
		line-height: 22px;
		letter-spacing: 0.2px;
	}

	/* make sure to override account-management */
	&& {
		margin: 0;
	}
`;
const Paragraph = ({ children, caption }) => {
    return react_1.default.createElement(P, { className: caption ? "caption" : "" }, children);
};
exports.Paragraph = Paragraph;
//# sourceMappingURL=Paragraph.atom.js.map